<section
  class="notesSection"
  [ngStyle]="getNotesPosition()"
  id="notesWrapper"
  *ngIf="isNotes"
  #notesSection
>
  <header class="notesHeader">
    <mat-icon
      aria-hidden="false"
      aria-label="Close Notes"
      (click)="notesCancel()"
      >close</mat-icon
    >
  </header>
  <div class="notesBody">
    <form [formGroup]="formGroup">
      <mat-radio-group
        aria-label="Select an option"
        *ngIf="noteAvailableFor.cellData.IsEdit"
        formControlName="ExtendSelection"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="updateRadioSelection($event)"
      >
        <mat-radio-button
          value="extend_upto"
          class="checkItemWrapper extendWrapper"
        >
          <span>Extend booking until</span>
          <mat-form-field
            class="date-wrapper"
            appearance="fill"
            class="extend_dp"
          >
            <input
              matInput
              autocomplete="off"
              [min]="minDate"
              [matDatepicker]="picker"
              [value]="date && date.value"
              (dateInput)="updateDate('input', $event)"
              (dateChange)="updateDate('change', $event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-icon
              class="date-clear"
              aria-hidden="false"
              aria-label="Clear date"
              (click)="clearDate()"
              >close
            </mat-icon>
          </mat-form-field>
        </mat-radio-button>
        <mat-radio-button
          *ngIf="checkIfNewBooking()"
          value="update_all"
          class="checkItemWrapper updateAllChekbox"
          >Find future bookings with matching value & Replace with revised
          value</mat-radio-button
        >
        <!-- Update the existing forward bookings with the revised value -->
      </mat-radio-group>
      <div class="bookingComponentWrapper">
        <section
          class="jobAssignmentComponent"
          *ngIf="loggedInUser.R_Enable_JobAssignDescr"
        >
          <label>Engagement Activity</label>
          <mat-form-field appearance="outline">
            <mat-select
              [(value)]="selectedJobAssignment"
              (selectionChange)="onJobAssignmentChange($event)"
              placeholder="Select Engagement Activity"
            >
              <mat-option
                class="no-data"
                *ngIf="!jobAssignmentList || jobAssignmentList.length === 0"
              >
                No Engagement Activity Found
              </mat-option>
              <ng-container *ngIf="jobAssignmentList.length > 0">
                <mat-option
                  [value]="jobAssignment.EngagementActivityID"
                  *ngFor="let jobAssignment of jobAssignmentList"
                >
                  {{ jobAssignment.EngagementActivityDescr }}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </section>
        <section
          class="bookingComponent"
          *ngIf="loggedInUser.R_Enable_CompDescr"
        >
          <div class="engComponentSearch">
            <label>Booking Component</label>
            <mat-form-field
              class="resourceSearch"
              appearance="outline"
              [ngClass]="{ 'is-invalid': isValidInput('EngagementComponent') }"
            >
              <input
                type="text"
                formControlName="EngagementComponent"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Search..."
                matInput
                autocomplete="off"
                appSearchDebounce
                (debounceKeyup)="searchBookingComponentData()"
                maxlength="75"
              />
              <mat-icon class="icon-close" (click)="resetBookingComponent()"
                >close</mat-icon
              >
            </mat-form-field>
            <div
              class="dropdown-list-wrap"
              *ngIf="showSearchBCList || showSearchBCLoader"
            >
              <mat-spinner
                *ngIf="showSearchBCLoader"
                [diameter]="40"
              ></mat-spinner>
              <ul *ngIf="showSearchBCList" class="dropdown-list">
                <li
                  *ngFor="let item of engagementComponentList"
                  (click)="OnEngagementBookingSelect($event, item)"
                  class="dropdown-list-item"
                >
                  {{ item.ComponentDescr }}
                </li>
              </ul>
              <div
                *ngIf="
                  showSearchBCLoader == false &&
                  engagementComponentList?.length == 0
                "
              >
                No Booking Component Found
              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="notesTextWrapper">
        <span>Notes</span>
        <textarea
          cols="30"
          rows="10"
          [disabled]="!noteAvailableFor.cellData.IsEdit"
          formControlName="NotesData"
          [ngModelOptions]="{ standalone: true }"
        ></textarea>
      </div>
    </form>
  </div>
  <div class="btnContainer" *ngIf="noteAvailableFor.cellData.IsEdit">
    <button
      mat-raised-button
      color="primary"
      class="submitButton"
      (click)="notesSubmit()"
      type="submit"
    >
      Apply
    </button>
  </div>
</section>
